<template>
  <div>
    <v-list class="conversation">
      <v-list-item>
        <v-badge
          bordered
          bottom
          :color="onlineUser.Online ? 'green' : 'red'"
          dot
          offset-x="30"
          offset-y="20"
        >
          <v-list-item-avatar size="50">
            <v-img
              v-if="onlineUser.Image != null"
              :src="onlineUser.Image"
            ></v-img>
            <v-img v-else src="../../assets/default.png"></v-img>
          </v-list-item-avatar>
        </v-badge>
        <v-list-item-content>
          <v-list-item-title v-text="onlineUser.Name"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import axios from "axios";
const url = require("../../client_config/config").url;

export default {
  props: {
    conversation: {
      type: Object,
      default: () => {},
    },
    userId: {
      type: String,
      default: "",
    },
    online: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      userConversations: [],
    };
  },

  computed: {
    onlineUser() {
      return {
        ...this.userConversations,
        Online: this.online.includes(this.userConversations._id) ? true : false,
      };
    },
  },
  created() {
    this.getUserConversation();
  },

  methods: {
    async getUserConversation() {
      this.userConversations = [];
      try {
        const staffId = this.conversation.members.find(
          (m) => m !== this.userId
        );
        const users = await axios(`${url}/users/userx?userId=${staffId}`);
        this.userConversations = users.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.conversation {
  cursor: pointer;
  padding: 0;
}

.conversation:hover {
  background-color: rgb(245, 243, 243);
}
</style>
